import React from 'react'
import Fade from 'react-reveal/Fade'

export default function MobileCategorisedVideos ({ category, videos, showVideo }) {
  return (
    <Fade>
      <p className="cat-title">{category}</p>
      <div className="list-container">
        {videos.filter(vid => vid.category === category).map((item, index) => (
          <div className="list-item" key={index} onClick={() => showVideo(item)}>
            <img
              alt="poster gallery item"
              src={item.thumbnail}
              className="list-image"
            />
            <button className="item-icon">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#26b4a9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                <circle cx="12" cy="12" r="10"></circle>
                <polygon points="10 8 16 12 10 16 10 8"></polygon>
              </svg>
            </button>
          </div>
        ))}
      </div>
    </Fade>
  )
}